// extracted by mini-css-extract-plugin
export default {"banner_img":"privacy-policy_banner_img__42YgA","hr":"privacy-policy_hr__-G13w"};